<template>
  <div class="foot" :class="{fadeinup:fadeinup}">
    <div class="top">
      <div class="left">
        <div class="item" :class="{en_item:$i18n.locale=='en'}" v-for="(item,index) in $t('foot').tlist" :key="index">
          <p style="cursor: pointer" @click="goto2(index)">{{item}}</p>
          <ul>
            <li v-for="(item2,index2) in $t('foot').List[index]" :key="index2">
              <a @click="goto(index,index2)">{{item2}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <img class="footlogo" src="../../public/image/dddlogo2.png" alt />
        <div class="allItem">
          <div class="item">
            <span>{{$t('foot').right.text0}}</span>
            <p>0574-87654666</p>
          </div>
          <div class="item">
            <span>{{$t('foot').right.text1[0]}}</span>
            <p>{{$t('foot').right.text1[1]}}</p>
          </div>
          <div class="item">
            <span>{{$t('foot').right.text2}}</span>
            <p>hvac@icoolglobal.com</p>
          </div>
        </div>
        <div class="allImage">
          <span>{{$t('foot').right.text3}}</span>
          <div class="image">
            <div class="border">
              <i class="iconfont icon-gongzhonghao"></i>
            </div>
            <div class="border">
              <img src="../../public/image/tiktok.png" alt="">
            </div>
            <div class="border">
              <i class="iconfont icon-toutiaoyangshi"></i>
            </div>
            <div class="border">
              <i class="iconfont icon-weibo"></i>
            </div>
            <div class="border">
              <i class="iconfont icon-facebook"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <p>Copyright © 1984 - 2020 {{$t('foot').cname}} All Rights Reserved <a href="https://beian.miit.gov.cn/" target="_blank">{{ beian }}</a></p>
        <p>
          <a href="http://www.seniorweb.cn" target="_blank">{{$t('foot').right.text4}}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "foot",
  data() {
    return {
      fadeinup: false,
      tlist: [
        "关于艾科",
        // "品牌故事",
        "企业责任",
        "产业领域",
        "新闻中心",
        "联系我们",
      ],
      List: [
        [
          "集团介绍",
          "发展历程",
          "集团品牌",
          "荣誉资质",
           "企业文化",
          "战略愿景"
        ],
        [],
        // [],
        ["制冷科技领域", "热泵科技领域", "管道通风科技领域", "新业务领域"],
        ["集团动态", "行业动态"],
        ["人力资源", "在线留言", "联系方式"],
      ],
      beian:'浙ICP备14018766号-4'
    };
  },
  mounted() {
    var host = window.location.host;
    console.log(host)
    if(host==='www.icoolglobal.com'||host==='icoolglobal.com'){
      this.beian='浙ICP备14018766号-1'
    }else{
      this.beian='浙ICP备14018766号-4'
    }
  },
  components: {},
  computed: {
    ...mapState(["shortMenu"]),
  },
  watch: {
    shortMenu(val) {
      if (val == "4" && !this.hasplay) {
        this.fadeinup = true;
      }
    },
  },
  methods: {
    goto2(n){
      if(n===2){
        window.open('./duty.html','_self')
      }
    },
    goto(n,i){
      if(n===4 && i===0){
        window.open('./contact.html','_self')
      }else if(n===4 && i===1){
        window.open('./message.html','_self')
      }else if(n===4 && i===2){
        window.open('./human.html','_self')
      }else if(n===0 && i===2){
        window.open('./culture.html?index=1','_self')
      }else if(n===0 && i===3){
        window.open('./culture.html?index=1','_self')
      }else if(n===0 && i<2){
        window.open(`./about.html?index=${i}`,'_self')
      }else if(n===1){
        const link=`./tech.html?index=${i}`
        window.open(link,'_self')
      }else if(n===3){
        const link=`./news.html?index=${i}`
        window.open(link,'_self')
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.foot {
  background-color: #2f2f2f;
  .top {
    display: flex;
    width: 90%;
    margin: 0 auto;
    .left {
      width: 65%;
      display: flex;
      justify-content: space-around;
      padding: 40px 0 200px 0;
      border-right: 1px solid rgba(255, 255, 255, 0.1);
      .item {
        width: 15%;
        p {
          color: white;
          font-size: 18px;
          text-align: center;
          font-family: "SOURCEHANSANSCN-REGULAR";
        }
        &:nth-child(1){
                li:nth-child(2){
                  display: none;
                }
            }
        ul {
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-top: 20px;
          
          li {
            list-style: none;
            line-height: 30px;
           
            a {
              color: white;
              font-size: 15px;
              font-family: "SOURCEHANSANSCN-LIGHT";
              transition: all 300ms;
              cursor: pointer;
              &:hover {
                color: #019bdb;
              }
            }
          }
        }
      }
      .en_item{
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        ul{

          li{
            text-align: left !important;
            width: 100%;
          }
        }
      }
      .en_item:nth-child(2){
        ul{
          li{
            line-height: 20px;
            margin-bottom: 10px;
            text-align: center;
          }
        }
      }
    }
    .right {
      width: 30%;
      margin: 0 auto;
      margin-right: 0;
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .footlogo {
        width: 185px;
      }
      .allItem {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        .item {
          width: 50%;
          span {
            font-family: "SOURCEHANSANSCN-REGULAR";
            color: white;
            font-size: 16px;
            line-height: 40px;
          }
          p {
            font-family: "SOURCEHANSANSCN-LIGHT";
            font-size: 20px;
            color: white;
          }
        }
        .item:nth-child(1) {
          margin-bottom: 30px;
        }
        .item:nth-child(2) {
          p {
            font-family: "SOURCEHANSANSCN-LIGHT";
            font-size: 16px;
          }
        }
        .item:nth-child(2) {
          p {
            color: white;
          }
        }
      }
      .allImage {
        margin-top: 40px;
        span {
          font-size: 20px;
          color: white;
        }
        .image {
          margin-top: 10px;
          display: flex;

          .border {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            border: 1px solid white;
            position: relative;
            margin-right: 10px;
            transition: all 300ms;
            cursor: pointer;
            &:hover {
              border: 1px solid #019bdb;
              background-color: #019bdb;
              i {
                color: white;
              }
              img{
                filter: brightness(1.6);
              }
            }
            i {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 20px;
              color: white;
            }
            img{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%,-50%);
              width: 18px;
              height: 20px;
            }
          }
          .border:nth-child(4) {
            i {
              font-size: 30px;
            }
          }
        }
      }
    }
  }
  .bottom {
    padding: 50px 0;
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    div {
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    p {
      color: white;
      font-family: "SOURCEHANSANSCN-LIGHT";
      font-size: 15px;
      a {
        color: white;
      }
    }
  }
  @media screen and (max-width: 1000px){
    .top{
      .left{
        display: none;
      }
      .right{
        width:100%;
        .item{
          width:100% !important;
          margin-bottom: 0;
        }
      }
    }
    .bottom{
      padding: 20px 0;
      p{
        text-align: center;
      }
      div{
        flex-direction: column;
      }
    }
  }
}
.fadeinup {
  animation: fadeInUp 4000ms;
  opacity: 1;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
